import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataDecimal,
  ODataEnum,
  ODataBoolean
} from "pbas-vue-components";
import { translate2 } from '../trans2'
import { translate } from '../trans'
import { i18n } from '@/plugins/i18n';
import store from '@/store'

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

const PaymentsHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("Term/Name"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("Term/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.contributionterms.name",
    type: new ODataString("Term/Translations[]/FullName", {
      getString: (item) => translate2(item.Term, "FullName")
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Term/Name"
  }),
  new ODataHeader({
    type: new ODataString("Term/Translations[]/RefId"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("Term/Translations[]/Id"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("Term/Id"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    type: new ODataString("TermId"),
    visible: false,
    searchable: false,
    allowVisibilityChange: false
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataEnum("Type", {
      getString: (item) => {
        return i18n.t("enums." + item.Type);
      },
      dropdownItems: store.getters['plansMembers/options']?store.getters['plansMembers/options'].Enums.PaymentType:[]
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "views.planbalance.cheque_number",
    type: new ODataString("PaymentNumber"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.selfpayments.payment_date",
    type: new ODataDate("PaymentDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.amount",
    type: new ODataDecimal("Amount", {
      getString: (item, type) => {
        const value = item.Amount;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new ODataHeader({
    title: "headers.selfpayments.deposited",
    type: new ODataBoolean("Deposited"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.payments.deposited_date",
    type: new ODataDate("DepositedAt"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
export default PaymentsHeaders;
